import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-foundations',
    templateUrl: './foundations.component.html',
    styleUrls: ['./foundations.component.scss'],
    imports:[CommonModule]
})
export class FoundationsComponent implements OnInit {

  title = "Investing for Foundations and Endowments.";

  // historical data begins in 1928
  yearsOfData = new Date().getFullYear() - 1928;

friendlyUrl = ""

  constructor(public router: Router, public activatedRoute: ActivatedRoute, private seoservice: SeoService, private meta: Meta) {

    
   }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'catholic foundation and endowments services, catholic foundations investing services, catholic endowments investing services'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Foundations and Endowment services.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

    this.activatedRoute.params.subscribe(resp => {
      this.friendlyUrl = resp.friendlyUrl?resp.friendlyUrl: "";
// $&(resp.friendlyUrl)
    })

// $&(this.activatedRoute.params)

  }

  navigate(path: string) {

    this.router.navigate(["/foundations/"+path])

  }

}
